import { Button } from "@src/appV2/redesign/components/Button";
import { LicenseStatusPill } from "@src/appV2/redesign/Licenses/LicenseStatusPill";

import { ShiftBottomSheetBookabilityCriteriaCard } from "../BookabilityCriteriaCard";

interface PendingLicenseCardProps {
  href: string;
}

export function PendingLicenseCard(props: PendingLicenseCardProps) {
  const { href } = props;

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="License is being reviewed"
      description="We're currently reviewing your license details. Our team will get back to you within 4 hours."
      illustrationType="document-upload"
      pill={<LicenseStatusPill status="PENDING" size="medium" />}
      footer={
        <Button fullWidth href={href} variant="outlined" size="medium">
          View Details
        </Button>
      }
    />
  );
}
